import { render, staticRenderFns } from "./OrderAddressChange.vue?vue&type=template&id=2df18938&scoped=true&"
import script from "./OrderAddressChange.vue?vue&type=script&lang=js&"
export * from "./OrderAddressChange.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddressChange.vue?vue&type=style&index=0&id=2df18938&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df18938",
  null
  
)

export default component.exports